export default "__VITE_ASSET__B3rN1pj$__"